
import NavHome from '../../home/components/NavHome'
import { Outlet } from 'react-router-dom';
import Footer from '../../home/components/Footer';
import Aside from '../Aside';
import useAuth from '../../auth/useAuth';
import { useEffect } from 'react';
import axios from 'axios';
import { constants } from '../../constants';


const DashboardLayout = (props) => { 

  useEffect(()=> {
    console.log('Renderizado DashboardLayout...')
  })

  async function logout() {
    try {
      const token = window.localStorage.getItem('at');
      const URL = constants.test_host + '/auth/logout';
      await axios.get(URL, {withCredentials: true}, {headers: {
        'authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }})
      .then((resp) => {
        console.log(resp);
        window.location.href= '/dashboard/user'
      })

      
    } catch (error) {
      console.log(error)
    }
    
  }
  
  return (
    <>
        <NavHome toggleSidebar = {props.toggleSidebar} width = {props.width} logout= {logout} />
        <Aside logout={logout} toggleSidebar = {props.toggleSidebar} handleToggle = {props.handleToggle} width = {props.width}/>
        <Outlet />
        <Footer toggleSidebar = {props.toggleSidebar} handleToggle = {props.handleToggle}/>
    </>
  )
}

export default DashboardLayout
